<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar color="white">
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Overall Totals</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="loading" align="center" justify="center">
        <v-col class="pt-0">
          <div class="progress-container">
            <v-progress-circular
              :size="75"
              :width="8"
              class="my-auto"
              color="primary"
              indeterminate
            />
          </div>
        </v-col>
      </v-row>
      <v-list v-if="!loading" class="py-0 align-self-center" dense>
        <!-- TODO: vue3 upgrade check if this is needed:  v-list-item-group has been removed, just add value to list items to make them selectable and bind v-model:selected on v-list to get the selected value.-->
        <v-list-item @click="categoryClick('all')">
          <v-row>
            <v-col cols="2" class="align-self-center">
              <v-img
                src="/images/active_referrals.png"
                max-height="30"
                max-width="30"
                contain
              />
            </v-col>
            <v-col class="align-self-center">
              <v-list-item-title class="font-weight-light font-14">
                Total Referrals
              </v-list-item-title>
            </v-col>
            <v-col cols="3">
              <v-list-item-action class="text-right justify-end">
                <span class="funnel-count text-h6 overall-totals-black-text">{{
                  totalReferrals
                }}</span>
              </v-list-item-action>
            </v-col>
          </v-row>
        </v-list-item>

        <!--   Follow-Ups     -->
        <v-list-subheader
          class="font-weight-regular font-14 grey--text text--darken-3 px-4"
        >
          Follow-Ups
        </v-list-subheader>
        <v-list-item @click="categoryClick('active')">
          <v-row>
            <v-col cols="2" class="align-self-center">
              <v-img
                src="/images/active_referrals.png"
                max-height="30"
                max-width="30"
                contain
              />
            </v-col>
            <v-col class="align-self-center">
              <v-list-item-title class="font-weight-light font-14"
                >Active Referrals</v-list-item-title
              >
            </v-col>
            <v-col cols="3">
              <v-list-item-action class="text-right justify-end">
                <span class="funnel-count text-h6 overall-totals-black-text">{{
                  activeReferrals
                }}</span>
              </v-list-item-action>
            </v-col>
          </v-row>
        </v-list-item>
        <v-list-item @click="categoryClick('overdue')">
          <v-row>
            <v-col cols="2" class="align-self-center">
              <v-img
                src="/images/overdue_followup.png"
                max-height="30"
                max-width="30"
                contain
              />
            </v-col>
            <v-col class="align-self-center">
              <v-list-item-title class="font-weight-light font-14"
                >Overdue for Follow-Up</v-list-item-title
              >
            </v-col>
            <v-col cols="3">
              <v-list-item-action class="text-right justify-end">
                <span class="funnel-count text-h6 red--text text--darken-2">{{
                  overdueFollowUp
                }}</span>
              </v-list-item-action>
            </v-col>
          </v-row>
        </v-list-item>

        <!--   Transactions     -->
        <v-list-subheader
          class="font-weight-regular font-14 grey--text text--darken-3 px-4"
          >Transactions</v-list-subheader
        >
        <v-list-item @click="categoryClick('closed')">
          <v-row>
            <v-col cols="2" class="align-self-center">
              <v-img
                src="/images/closed.png"
                max-height="30"
                max-width="30"
                contain
              />
            </v-col>
            <v-col class="align-self-center">
              <v-list-item-title class="font-weight-light font-14"
                >Closed</v-list-item-title
              >
            </v-col>
            <v-col cols="3">
              <v-list-item-action class="text-right justify-end">
                <span class="funnel-count text-h6 overall-totals-black-text">{{
                  closed
                }}</span>
              </v-list-item-action>
            </v-col>
          </v-row>
        </v-list-item>
        <v-list-item @click="categoryClick('removed')">
          <v-row>
            <v-col cols="2" class="align-self-center">
              <v-img
                src="/images/removed.png"
                max-height="30"
                max-width="30"
                contain
              />
            </v-col>
            <v-col class="align-self-center">
              <v-list-item-title class="font-weight-light font-14"
                >Removed</v-list-item-title
              >
            </v-col>
            <v-col cols="3">
              <v-list-item-action class="text-right justify-end">
                <span class="funnel-count text-h6 overall-totals-black-text">{{
                  removed
                }}</span>
              </v-list-item-action>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
import api from "@/services/api.js";
import { mapGetters } from "vuex";

export default {
  name: "console-overview-overall-totals",
  components: {},
  props: {
    product: {
      type: String,
      default: "COMBINED",
    },
  },
  watch: {
    product() {
      console.log(`product changed: ${this.product}`);
      this.parseProductData();
    },
  },
  data() {
    return {
      loading: false,
      statData: {},
      totalReferrals: 0,
      activeReferrals: "-",
      overdueFollowUp: "-",
      closed: "-",
      removed: "-",
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage", "isAdmin", "isLeadSupplier"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    categoryClick(cat) {
      let query = {};
      // if (this.product === "PRIMESTREET") {
      //   query["productFamily"] = "PrimeStreet";
      // } else if (this.product === "LEAD_GENIUS") {
      //   query["productFamily"] = "LeadGenius";
      // } else {
      //   query["productFamily"] = "PrimeStreet";
      // }

      if (cat === "overdue") {
        query["followupType"] = "OVERDUE";
        // overdue is the only one currently including PS+LG
        // query["productFamily"] = "";
      } else {
        query["category"] = cat;
      }
      this.$router.push({
        name: "my-referrals",
        query: query,
      });
    },
    parseProductData() {
      switch (this.product) {
        case "PRIMESTREET":
          this.parsePrimestreetData();
          break;

        case "LEAD_GENIUS":
          this.parseLeadGeniusData();
          break;

        case "COMBINED":
          this.parseCombinedData();
          break;
      }
    },
    parsePrimestreetData() {
      this.totalReferrals = 0;

      // active referrals count
      this.activeReferrals = "-";
      if (
        this.statData.activeReferrals !== undefined &&
        this.statData.activeReferrals !== null
      ) {
        this.activeReferrals = this.statData.activeReferrals;
        this.totalReferrals += this.activeReferrals;
      }

      // overdue follow up
      this.overdueFollowUp = "-";
      if (
        this.statData.overdueForFollowUp !== undefined &&
        this.statData.overdueForFollowUp !== null
      ) {
        this.overdueFollowUp = this.statData.overdueForFollowUp;
      }

      // closed, updated to totalClosed per ticket 842
      this.closed = "-";
      if (
        this.statData.totalClosed !== undefined &&
        this.statData.totalClosed !== null
      ) {
        this.closed = this.statData.totalClosed;
        this.totalReferrals += this.closed;
      }

      // removed count
      this.removed = "-";
      if (
        this.statData.removed !== undefined &&
        this.statData.removed !== null
      ) {
        this.removed = this.statData.removed;
        this.totalReferrals += this.removed;
      }
    },
    parseLeadGeniusData() {
      this.totalReferrals = 0;

      // active referrals count
      this.activeReferrals = "-";
      if (
        this.statData.leadGeniusActiveReferrals !== undefined &&
        this.statData.leadGeniusActiveReferrals !== null
      ) {
        this.activeReferrals = this.statData.leadGeniusActiveReferrals;
        this.totalReferrals += this.activeReferrals;
      }

      // overdue follow up
      this.overdueFollowUp = "-";
      if (
        this.statData.leadGeniusOverdueForFollowUp !== undefined &&
        this.statData.leadGeniusOverdueForFollowUp !== null
      ) {
        this.overdueFollowUp = this.statData.leadGeniusOverdueForFollowUp;
      }

      // closed
      this.closed = "-";
      if (
        this.statData.leadGeniusTotalClosed !== undefined &&
        this.statData.leadGeniusTotalClosed !== null
      ) {
        this.closed = this.statData.leadGeniusTotalClosed;
        this.totalReferrals += this.closed;
      }

      // removed count
      this.removed = "-";
      if (
        this.statData.leadGeniusRemoved !== undefined &&
        this.statData.leadGeniusRemoved !== null
      ) {
        this.removed = this.statData.leadGeniusRemoved;
        this.totalReferrals += this.removed;
      }
    },
    parseCombinedData() {
      this.totalReferrals = 0;

      // active referrals count
      this.activeReferrals = "-";
      if (
        this.statData.activeReferrals !== undefined &&
        this.statData.activeReferrals !== null &&
        this.statData.leadGeniusActiveReferrals !== undefined &&
        this.statData.leadGeniusActiveReferrals !== null
      ) {
        this.activeReferrals =
          this.statData.activeReferrals +
          this.statData.leadGeniusActiveReferrals;
        this.totalReferrals += this.activeReferrals;
      } else if (
        this.statData.activeReferrals !== undefined &&
        this.statData.activeReferrals !== null
      ) {
        this.activeReferrals = this.statData.activeReferrals;
        this.totalReferrals += this.activeReferrals;
      } else if (
        this.statData.leadGeniusActiveReferrals !== undefined &&
        this.statData.leadGeniusActiveReferrals !== null
      ) {
        this.activeReferrals = this.statData.leadGeniusActiveReferrals;
        this.totalReferrals += this.activeReferrals;
      }

      // overdue follow up
      this.overdueFollowUp = "-";
      if (
        this.statData.overdueForFollowUp !== undefined &&
        this.statData.overdueForFollowUp !== null &&
        this.statData.leadGeniusOverdueForFollowUp !== undefined &&
        this.statData.leadGeniusOverdueForFollowUp !== null
      ) {
        this.overdueFollowUp =
          this.statData.overdueForFollowUp +
          this.statData.leadGeniusOverdueForFollowUp;
      } else if (
        this.statData.overdueForFollowUp !== undefined &&
        this.statData.overdueForFollowUp !== null
      ) {
        this.overdueFollowUp = this.statData.overdueForFollowUp;
      } else if (
        this.statData.leadGeniusOverdueForFollowUp !== undefined &&
        this.statData.leadGeniusOverdueForFollowUp !== null
      ) {
        this.overdueFollowUp = this.statData.leadGeniusOverdueForFollowUp;
      }

      // closed
      this.closed = "-";
      if (
        this.statData.totalClosed !== undefined &&
        this.statData.totalClosed !== null &&
        this.statData.leadGeniusTotalClosed !== undefined &&
        this.statData.leadGeniusTotalClosed !== null
      ) {
        this.closed =
          this.statData.totalClosed + this.statData.leadGeniusTotalClosed;
        this.totalReferrals += this.closed;
      } else if (
        this.statData.totalClosed !== undefined &&
        this.statData.totalClosed !== null
      ) {
        this.closed = this.statData.totalClosed;
        this.totalReferrals += this.closed;
      } else if (
        this.statData.leadGeniusTotalClosed !== undefined &&
        this.statData.leadGeniusTotalClosed !== null
      ) {
        this.closed = this.statData.leadGeniusTotalClosed;
        this.totalReferrals += this.closed;
      }

      // removed count
      this.removed = "-";
      if (
        this.statData.removed !== undefined &&
        this.statData.removed !== null &&
        this.statData.leadGeniusRemoved !== undefined &&
        this.statData.leadGeniusRemoved !== null
      ) {
        this.removed = this.statData.removed + this.statData.leadGeniusRemoved;
        this.totalReferrals += this.removed;
      } else if (
        this.statData.removed !== undefined &&
        this.statData.removed !== null
      ) {
        this.removed = this.statData.removed;
        this.totalReferrals += this.removed;
      } else if (
        this.statData.leadGeniusRemoved !== undefined &&
        this.statData.leadGeniusRemoved !== null
      ) {
        this.removed = this.statData.leadGeniusRemoved;
        this.totalReferrals += this.removed;
      }
    },
    async loadSalesFunnel() {
      this.loading = true;
      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage) {
        try {
          let { data } = await api.brokerage.stats(brokerage);
          this.statData = data;
          this.parseProductData();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        // TODO: Handle no brokerage set
        this.loading = false;
      }
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewOverallTotalsToolTip");
    },
  },
  mounted() {
    this.loadSalesFunnel();
  },
};
</script>

<style scoped>
/*See ConsoleOverview for non-scoped classes*/
.card-container {
  min-height: 420px;
}

.overall-totals-black-text {
  color: black;
}

.progress-container {
  width: 100%;
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.font-14 {
  font-size: 14px !important;
}
</style>
